import {Bubble} from "./bubble";

export function Bubbles(bubblesEl, isMultiple, onClick) {
    this.bubblesElement = bubblesEl;
    this.hintElement = bubblesEl.getElementsByClassName('hint')[0];

    this.update = function (values, options) {
        this.bubblesElement.innerText = '';

        if (!values.length) {
            this.bubblesElement.appendChild(this.hintElement);
        } else {
            let i = isMultiple ? 0 : values.length - 1;
            for (i; i < values.length; i++) {
                const item = options[values[i]];
                const bubble = new Bubble(item, isMultiple, onClick);
                this.bubblesElement.appendChild(bubble.elem());
            }
        }
    }
}